import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';

import { Button, ButtonStyleEnum, Separator } from '@components';
import { useViewerModel } from '@models/Viewer/ViewerModel';
import { ToastService } from '@services';
import { parseApiError } from '@utils';
import { usePersonalizationNavigation } from '@hooks';

export const SuggestedUsersListFooter = observer(() => {
  const { t } = useTranslation();
  const viewer = useViewerModel();
  const { navigateToNextScreen } = usePersonalizationNavigation();

  async function save() {
    try {
      await viewer.usersSuggestion.save.run();

      navigateToNextScreen();
    } catch (error) {
      ToastService.showError(parseApiError(error).message);
    }
  }

  async function skipForNow() {
    try {
      await viewer.usersSuggestion.skipAndSave.run();

      navigateToNextScreen();
    } catch (error) {
      ToastService.showError(parseApiError(error).message);
    }
  }

  async function skipAndNeverAsk() {
    try {
      await viewer.usersSuggestion.skipAndNeverAsk.run();

      navigateToNextScreen();
    } catch (error) {
      ToastService.showError(parseApiError(error).message);
    }
  }

  const isDisabledSaveButton =
    viewer.usersSuggestion.skipAndNeverAsk.inProgress ||
    viewer.usersSuggestion.skipAndSave.inProgress;

  const isDisabledSkipButton =
    viewer.usersSuggestion.skipAndNeverAsk.inProgress ||
    viewer.usersSuggestion.save.inProgress;

  const isDisabledNewerAskButton =
    viewer.usersSuggestion.skipAndSave.inProgress ||
    viewer.usersSuggestion.save.inProgress;

  return (
    <View>
      <Button
        onPress={save}
        isLoading={viewer.usersSuggestion.save.inProgress}
        disabled={isDisabledSaveButton}
      >
        {t('usersSuggestion.next')}
      </Button>

      <Separator size="$5" />
      <Button
        buttonStyle={ButtonStyleEnum.Outline}
        onPress={skipForNow}
        isLoading={viewer.usersSuggestion.skipAndSave.inProgress}
        disabled={isDisabledSkipButton}
      >
        {t('usersSuggestion.skip')}
      </Button>

      <Separator size="$5" />
      <Button
        buttonStyle={ButtonStyleEnum.Ghost}
        onPress={skipAndNeverAsk}
        isLoading={viewer.usersSuggestion.skipAndNeverAsk.inProgress}
        disabled={isDisabledNewerAskButton}
      >
        {t('usersSuggestion.skipNeverAsk')}
      </Button>
    </View>
  );
});
